module.exports = __webpack_public_path__ + "static/media/guide_img2_2_m.fac0e013.png";